import LocationInfo from "@/pages/locaties/gegevens/LocationInfo"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/locaties/$locationId/gegevens/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { locationId } = useParams({
    from: "/beheer/locaties/$locationId",
  })

  return <LocationInfo locationId={Number(locationId)} />
}
